import { gql } from '@apollo/client';
import devNote from '@xingternal/dev-note';
import { XingFrameQueryDocument } from './xingFrameQuery.gql-types';

const initialize = async ({ client, broadcastError }) => {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q;
    try {
        const result = await client.query({
            query: gql`query xingFrameQueryCached { viewer { id featureSwitches } }`,
            fetchPolicy: 'cache-only',
            errorPolicy: 'all',
        });
        const { loading, error, data } = await client.query({
            query: XingFrameQueryDocument,
            errorPolicy: 'all',
        });
        if (error) {
            broadcastError(error, 'The GET_INITIAL_DATA query call has returned an error!');
        }

        return {
            data: {
                user: (_b = (_a = data === null || data === void 0 ? void 0 : data.viewer) === null || _a === void 0 ? void 0 : _a.xingId) !== null && _b !== void 0 ? _b : {},
                features: (_d = (_c = data === null || data === void 0 ? void 0 : data.viewer) === null || _c === void 0 ? void 0 : _c.features) !== null && _d !== void 0 ? _d : {},
                featureSwitches: result.data?.viewer?.featureSwitches ?? [],
                hashedUserId: (_j = (_h = (_g = data === null || data === void 0 ? void 0 : data.viewer) === null || _g === void 0 ? void 0 : _g.webTrackingData) === null || _h === void 0 ? void 0 : _h.PropHashedUserId) !== null && _j !== void 0 ? _j : '',
                willingnessToChangeJobs: (_o = (_m = (_l = (_k = data === null || data === void 0 ? void 0 : data.viewer) === null || _k === void 0 ? void 0 : _k.tracy) === null || _l === void 0 ? void 0 : _l.willingnessToChangeJobs) === null || _m === void 0 ? void 0 : _m.probability) !== null && _o !== void 0 ? _o : 0,
                networkEfficiencyIndicator: (_q = (_p = data === null || data === void 0 ? void 0 : data.viewer) === null || _p === void 0 ? void 0 : _p.networkEfficiencyIndicator) !== null && _q !== void 0 ? _q : {},
            },
            meta: {
                loading: loading || false,
                error,
            },
        };
    }
    catch (error) {
        broadcastError(error, 'The GET_INITIAL_DATA query call has thrown an error!');
        return {
            data: {
                user: {},
                features: {},
                featureSwitches: [],
                hashedUserId: '',
                willingnessToChangeJobs: 0,
                networkEfficiencyIndicator: {},
            },
            meta: {
                loading: true,
                error,
            },
        };
    }
};
const getHooks = (useFrameHooks) => {
    const useInitialData = () => {
        const { useFrameContext } = useFrameHooks();
        const { user, features, featureSwitches, hashedUserId, willingnessToChangeJobs, networkEfficiencyIndicator, loading, } = useFrameContext();
        const xingId = {
            ...user,
            ...(user && {
                // If user.id is available
                ...(user.id && {
                    get unscrambledId() {
                        // if user.id is a number, return it. Otherwise, parse and return the int part of it
                        return typeof user.id === 'string'
                            ? parseInt(user.id.split('.')[0])
                            : user.id;
                    },
                }),
                // If user.occupationOrg or user.occupationTitle is used
                profileOccupation: {
                    get occupationOrg() {
                        devNote.warn('occupationOrg is deprecated. Please use `user.occupations[0].headline`.');
                        return user.occupations && user.occupations.length
                            ? user.occupations[0].headline
                            : '';
                    },
                    get occupationTitle() {
                        devNote.warn('occupationTitle is deprecated. Please use `user.occupations[0].subline`.');
                        return user.occupations && user.occupations.length
                            ? user.occupations[0].subline
                            : '';
                    },
                },
            }),
        };
        return {
            user: xingId,
            features,
            featureSwitches,
            hashedUserId,
            willingnessToChangeJobs,
            networkEfficiencyIndicator,
            loading,
        };
    };
    return { useInitialData };
};
export const initialDataModule = {
    name: 'initialDataModule',
    initialize,
    getHooks,
};
//# sourceMappingURL=initial-data.js.map